import * as ko from "knockout";
import { NewspaperRequestFormComponent } from "./Components/NewspaperRequestForm/newspaperRequestForm";
import { SitePanelComponent } from "./Components/SitePanel/sitePanel";
import { NewspaperRequestTableComponent } from "./Components/NewspaperRequestTable/newspaperRequestTable";
import { NewspaperRequestPageComponent } from "./Components/NewspaperRequestPage/newspaperRequestPage";
import { SubscriptionReportFormComponent } from "./Components/SubscriptionReportForm/subscriptionReportForm";
import { SubscriptionPageComponent } from "./Components/SubscriptionPage/subscriptionPage";
import { LiveSubscriptionPageComponent } from "./Components/LiveSubscriptionPage/liveSubscriptionPage";
import { LiveSubscriptionReportFormComponent } from "./Components/LiveSubscriptionReportForm/liveSubscriptionReportForm";
import { NewspaperRequestFullTableComponent } from "./Components/NewspaperRequestFullTable/newspaperRequestFullTable";
import { NewspaperRequestHalfTableComponent } from "./Components/NewspaperRequestHalfTable/newspaperRequestHalfTable";

export class ComponentRegistration {

    static registerComponents = () => {

        ko.components.register("ko-newspaper-request-form", new NewspaperRequestFormComponent());
        ko.components.register("ko-site-accordion-panel", new SitePanelComponent());
        ko.components.register("ko-newspaper-request-table", new NewspaperRequestTableComponent());
        ko.components.register("ko-newspaper-request-table-full", new NewspaperRequestFullTableComponent());
        ko.components.register("ko-newspaper-request-table-half", new NewspaperRequestHalfTableComponent());
        ko.components.register("ko-newspaper-request-page", new NewspaperRequestPageComponent());
        ko.components.register("ko-subscription-form", new SubscriptionReportFormComponent());
        ko.components.register("ko-subscription-page", new SubscriptionPageComponent());
        ko.components.register("ko-livesubscription-page", new LiveSubscriptionPageComponent());
        ko.components.register("ko-livesubscription-form", new LiveSubscriptionReportFormComponent());
    }

}